import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#396DDD',
    },
    secondary: {
      main: '#3CBA84',
    },
      third: {
      main: '#e02727',
    },
  },
  typography: {
    fontWeightLight: 700,
    fontWeightRegular: 700,
    fontWeightMedium: 700,
    fontWeightBold: 700,
    allVariants: {
      fontWeight: 700,
    },
    button: {
      textTransform: 'none',
      fontWeight: 700,
    },
  },
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        position: 'unset !important', 
      },
    },
  },
});

export default theme;
